import actionTypes from './actionTypes';
import type { IRateCardValidation } from '../types';

const actions = {
  publishRequest: (payload: { id: string }) => ({
    type: actionTypes.PUBLISH_REQUEST,
    payload,
  }),
  publishSuccess: (payload: { cardId: string }) => ({ type: actionTypes.PUBLISH_SUCCESS, payload }),
  /** `conflict` means a publish is already running — a retry, not something to correct. */
  publishError: (payload: { errors: string[]; conflict?: boolean }) => ({
    type: actionTypes.PUBLISH_ERROR,
    payload,
  }),
  clearPublishState: () => ({ type: actionTypes.CLEAR_PUBLISH_STATE }),

  loadValidationRequest: (payload: { id: string }) => ({ type: actionTypes.LOAD_VALIDATION_REQUEST, payload }),
  loadValidationSuccess: (payload: IRateCardValidation) => ({ type: actionTypes.LOAD_VALIDATION_SUCCESS, payload }),
  loadValidationError: () => ({ type: actionTypes.LOAD_VALIDATION_ERROR }),

  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
